import React from 'react'
import './LanNavbar.css'
import logo from "./../../Assets/Vector.png"

function LanNavbar() {

    const observer = new IntersectionObserver((enteries) => {
        enteries.forEach((entry) => {
          console.log(entry);
          if(entry.isIntersecting){
            entry.target.classList.add('show');
          }
        })
      })
    
      setTimeout(() => {
      const hiddenElements = document.querySelectorAll('.hidden');
      hiddenElements.forEach((el) => observer.observe(el));
      });


    return (
        <nav className='hidden' >
        <div class="logo-title">
            <img className='logo_img_nav' src={logo} alt='logo'/>
            <span>SheildScan</span>
        </div>

        <div class="nav-links">
            <a href="/docs/emailspam">Docs</a>
            <a href="/#deal_lan">Pricing</a>
            <a href="/contactus">Contact Us</a>
        </div>

        <div class="login-btn">
            <button className='auth_btn login_btn'>Login</button>
            <button className='auth_btn register_btn'>Register</button>
        </div>
    </nav>
    )
}

export default LanNavbar
